var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayerVsCpu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "46px",
    viewBox: "0 0 82 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "player-vs-cpu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "player-vs-cpu"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-20",
    fill: "#FFFFFF",
    cx: 59,
    cy: 23,
    r: 23
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(39.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-11",
    fill: "#FD6687",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(10.000000, 12.500000)",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12.0833333,
    y1: 0.416666667,
    x2: 17.0833333,
    y2: 0.416666667,
    id: "Path-Copy"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.91666667,
    y1: 0.416666667,
    x2: 7.91666667,
    y2: 0.416666667,
    id: "Path-Copy-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 6.25,
    x2: 20,
    y2: 6.25,
    id: "Path-2"
  })))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-19",
    fill: "#FFFFFF",
    cx: 23,
    cy: 23,
    r: 23
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-11",
    fill: "#FD6687",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(10.000000, 11.666667)",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,22.2916667 C10.5228475,22.2916667 15,17.8145142 15,12.2916667 C15,6.76881917 10.5228475,2.29166667 5,2.29166667",
    id: "Oval-Copy-11",
    transform: "translate(10.000000, 12.291667) rotate(90.000000) translate(-10.000000, -12.291667) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(5.625000, 0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.416666667,
    y1: 0,
    x2: 0.416666667,
    y2: 4.98700291,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.75,
    y1: 0,
    x2: 8.75,
    y2: 4.98700291,
    id: "Path-Copy"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerVsCpu);
export default __webpack_public_path__ + "static/media/player-vs-cpu.c864805caf4d283a8c1f506a4b7452a5.svg";
export { ForwardRef as ReactComponent };